// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';

// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

export const Staff: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity="0.34">
        <path d="M2 13.0526C2 10.5263 4.43756 8.74251 6.95509 8.95303C7.31168 8.98284 7.66319 9 8 9C8.33681 9 8.68832 8.98284 9.04491 8.95303C11.5624 8.74251 14 10.5263 14 13.0526C14 13.5758 13.5758 14 13.0526 14H2.94737C2.42415 14 2 13.5758 2 13.0526Z" />
        <circle cx="8" cy="5" r="3" />
      </g>
    </SvgIcon>
  );
};
